module.exports = __webpack_public_path__ + "static/media/img_mobile_premiem_01.4269f131.png";